(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2212],{

/***/ 99914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WithUserId; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useSession.ts
var useSession = __webpack_require__(43001);
;// CONCATENATED MODULE: ./src/helpers/auth/withSession.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function WithSession(ComposedComponent) {
    return function WithSession(props) {
        var session = (0,useSession/* default */.Z)();
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposedComponent, _objectSpread({}, props, {
            session: session
        }));
    };
};

;// CONCATENATED MODULE: ./src/helpers/auth/withUserId.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function withUserId_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function withUserId_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            withUserId_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



function WithUserId(ComposedComponent) {
    var WithUserId1 = /*#__PURE__*/ function(_Component) {
        "use strict";
        _inherits(WithUserId1, _Component);
        var _super = _createSuper(WithUserId1);
        function WithUserId1() {
            _classCallCheck(this, WithUserId1);
            return _super.apply(this, arguments);
        }
        var _proto = WithUserId1.prototype;
        _proto.render = function render() {
            var userId = this.props.session.userId;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposedComponent, withUserId_objectSpread({}, this.props, {
                userId: userId
            }));
        };
        return WithUserId1;
    }(react.Component);
    return WithSession(WithUserId1);
};


/***/ }),

/***/ 55192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollTo; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var supportsNativeSmoothScroll = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function scrollTo(param) {
    var element = param.element, _top = param.top, top = _top === void 0 ? 0 : _top, _left = param.left, left = _left === void 0 ? 0 : _left;
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) {
        return;
    }
    element = (element === null || element === void 0 ? void 0 : element.scrollTo) && typeof (element === null || element === void 0 ? void 0 : element.scrollTo) === "function" ? element : window;
    if (!element) {
        return;
    }
    if (supportsNativeSmoothScroll) {
        element.scrollTo({
            top: top,
            left: left,
            behavior: "smooth"
        });
        return;
    }
    try {
        element.scrollTo(left, top);
    } catch (error) {
        try {
            element.scrollTop = top;
            element.scrollLeft = left;
        } catch (error) {}
    }
};


/***/ }),

/***/ 30531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getAdminDashboardUrl; }
});

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
;// CONCATENATED MODULE: ./src/providers/adminDashboardV2Url.ts

var urls = {
    local: "http://webadmin.local:5140",
    dev: "https://webadmin.bejusto.com",
    prod: "https://webadmin.getjusto.com"
};
var env = (0,getEnv/* default */.Z)();
/* harmony default export */ var adminDashboardV2Url = (urls[env]);

;// CONCATENATED MODULE: ./src/helpers/websites/getAdminDashboardUrl.ts

function getAdminDashboardUrl(websiteId) {
    var subpath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return "".concat(adminDashboardV2Url, "/").concat(websiteId, "/admin").concat(subpath);
};


/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* unused harmony exports DEFAULT_DESKTOP_WIDTH, DEFAULT_MOBILE_WIDTH */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95078);




var DEFAULT_DESKTOP_WIDTH = 1920;
var DEFAULT_MOBILE_WIDTH = 360;
function useWidth() {
    var ssrMobileOrDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var ssrWidth = ssrMobileOrDesktop === "mobile" ? DEFAULT_MOBILE_WIDTH : DEFAULT_DESKTOP_WIDTH;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() ? ssrWidth : window.innerWidth), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function handler() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
        };
    }, []);
    return width !== null && width !== void 0 ? width : ssrWidth;
};


/***/ }),

/***/ 17854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WebsiteCoinsImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56036);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);



function WebsiteCoinsImage(param) {
    var _customStyle = param.customStyle, customStyle = _customStyle === void 0 ? null : _customStyle;
    var style = (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-center mr-1 w-5 relative justify-center", customStyle);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            src: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FM6Wexw4yRsJDacfMJ-website-coins.svg",
            alt: "WebsiteCoinsLogo",
            title: "websiteCoinsLogo",
            height: 20,
            width: 20,
            objectFit: "contain",
            layout: "fill"
        })
    });
};


/***/ }),

/***/ 79354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShouldUseLoyaltyV2; }
/* harmony export */ });
/* harmony import */ var _hooks_useExperiment_experiments__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13505);

function useShouldUseLoyaltyV2() {
    var branchName = (0,_hooks_useExperiment_experiments__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("loyalty-justo");
    return branchName === "show";
};


/***/ }),

/***/ 69475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoginButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5434);
/* harmony import */ var _helpers_auth_loginViaAuth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63601);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80449);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);




function LoginButton() {
    var loginViaAuth = (0,_helpers_auth_loginViaAuth__WEBPACK_IMPORTED_MODULE_1__/* .useLoginViaAuthWindow */ .l)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
        onClick: function() {
            return loginViaAuth();
        },
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().menuText),
        children: [
            "Iniciar sesi\xf3n ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_3__/* .MdLogin */ .HOZ, {})
        ]
    });
};


/***/ }),

/***/ 59874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WebsiteCoins; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _page_components_CheckoutV3_sections_useShouldUseLoyaltyV2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79354);
/* harmony import */ var _page_components_CheckoutV3_sections_WebsiteCoins_WebsiteCoinsCount_WebsiteCoinsImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17854);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




function WebsiteCoins(props) {
    var showJustoLoyaltyV2 = (0,_page_components_CheckoutV3_sections_useShouldUseLoyaltyV2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    if (!showJustoLoyaltyV2) return null;
    var loyaltyProgramConfig = props.loyaltyProgramConfig, me = props.me;
    if (!(loyaltyProgramConfig === null || loyaltyProgramConfig === void 0 ? void 0 : loyaltyProgramConfig.active) || !(me === null || me === void 0 ? void 0 : me.websiteCoinsBalance) && (me === null || me === void 0 ? void 0 : me.websiteCoinsBalance) !== 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: "/justoloyalty",
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex px-2 py-1",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_CheckoutV3_sections_WebsiteCoins_WebsiteCoinsCount_WebsiteCoinsImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                me.websiteCoinsBalance
            ]
        })
    });
};


/***/ }),

/***/ 3967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Menu; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-addons-css-transition-group/index.js
var react_addons_css_transition_group = __webpack_require__(19081);
var react_addons_css_transition_group_default = /*#__PURE__*/__webpack_require__.n(react_addons_css_transition_group);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/helpers/auth/logout.ts
var logout = __webpack_require__(69073);
// EXTERNAL MODULE: ./src/helpers/auth/withUserId.tsx + 1 modules
var withUserId = __webpack_require__(99914);
// EXTERNAL MODULE: ./src/helpers/events/index.ts
var events = __webpack_require__(52860);
// EXTERNAL MODULE: ./src/helpers/misc/getContrastColor.ts
var getContrastColor = __webpack_require__(97915);
// EXTERNAL MODULE: ./src/helpers/router/getPathname.ts
var getPathname = __webpack_require__(48024);
// EXTERNAL MODULE: ./src/helpers/websites/withWebsiteId.tsx
var withWebsiteId = __webpack_require__(91015);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/helpers/sleep.js
var sleep = __webpack_require__(97537);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withGraphQL.js
var withGraphQL = __webpack_require__(70791);
// EXTERNAL MODULE: ./node_modules/autobind-decorator/lib/esm/index.js
var esm = __webpack_require__(88572);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var dist_esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/i18n/formatNumber/index.ts + 1 modules
var formatNumber = __webpack_require__(78263);
// EXTERNAL MODULE: ./src/page-components/CheckoutV3/sections/useShouldUseLoyaltyV2.ts
var useShouldUseLoyaltyV2 = __webpack_require__(79354);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/Points/styles.module.css
var styles_module = __webpack_require__(57905);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/Points/index.tsx







function Points(props) {
    var ref;
    var showJustoLoyaltyV2 = (0,useShouldUseLoyaltyV2/* default */.Z)();
    var t = (0,dist_esm/* useTranslation */.$G)("website", {
        keyPrefix: "layout.layouts.default.navbar.menu.points"
    }).t;
    if (showJustoLoyaltyV2) return null;
    if (!(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.active)) return null;
    var pointsInWebsite = props.user.pointsInWebsite;
    var name = props.config.name;
    var descriptionText = pointsInWebsite >= 1000 ? "labelRedeemForDiscountsCoupons" : "labelPurchaseAccumulates";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/canjear",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).button,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).title,
                    children: t("labelAmountPoints", {
                        points: (0,formatNumber/* default */.Z)(pointsInWebsite, "0,0.[00]"),
                        name: name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).description,
                    children: t(descriptionText, {
                        name: name
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/helpers/websites/getAdminDashboardUrl.ts + 1 modules
var getAdminDashboardUrl = __webpack_require__(30531);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/styles.module.css
var Menu_styles_module = __webpack_require__(80449);
var Menu_styles_module_default = /*#__PURE__*/__webpack_require__.n(Menu_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/AdminLink.tsx








function AdminLink() {
    var t = (0,dist_esm/* useTranslation */.$G)("website", {
        keyPrefix: "layout.layouts.default.navbar.menu"
    }).t;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: (0,getAdminDashboardUrl/* default */.Z)(websiteId, ""),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            target: "_blank",
            className: (Menu_styles_module_default()).menuLink,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdControlPoint */.Tif, {
                    size: 20
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: t("labelAdmin")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/canViewAdmin.ts
function CanViewAdmin(me) {
    if (!me) return false;
    var roles = me.roles, roleInWebsite = me.roleInWebsite;
    if (roles && roles.length) return true;
    if (!roleInWebsite) return false;
    return [
        "admin",
        "marketing",
        "content",
        "storeAdmin"
    ].includes(roleInWebsite.role);
};

;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/canViewPos.ts
function CanViewPos(me) {
    if (!me) return false;
    var roles = me.roles, roleInWebsite = me.roleInWebsite;
    if (roles && roles.length) return true;
    if (!roleInWebsite) return false;
    return [
        "admin",
        "operator",
        "storeAdmin"
    ].includes(roleInWebsite.role);
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/LoginButton.tsx
var LoginButton = __webpack_require__(69475);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/WebsiteCoins/index.tsx
var WebsiteCoins = __webpack_require__(59874);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/index.tsx
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    query getMeInNavbar($websiteId: ID) {\n      me {\n        _id\n        name\n        email\n        roles\n        roleInWebsite(websiteId: $websiteId) {\n          _id\n          role\n        }\n        pointsInWebsite(websiteId: $websiteId)\n        websiteCoinsBalance(websiteId: $websiteId)\n      }\n\n      loyaltyProgramConfig(websiteId: $websiteId) {\n        _id\n        name\n        active\n        maxRedeemAmount\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
























var _class, _dec, _dec1, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7;
var translatePrefix = "layout.layouts.default.navbar.menu";
var _dec8 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _dec9 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec10 = (0,withGraphQL["default"])((0,lib["default"])(_templateObject()), {
    loading: null
});
var User = _class = (0,withWebsiteId/* default */.Z)(_class = _dec10(_class = (0,withUserId/* default */.Z)(_class = _dec9(_class = _dec8(((_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(User, _Component);
    var _super = _createSuper(User);
    function User(props) {
        _classCallCheck(this, User);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            open: _this.props.open
        };
        return _this;
    }
    var _proto = User.prototype;
    _proto.componentDidMount = function componentDidMount() {
        window.addEventListener("mouseup", this.closeMenu, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("mouseup", this.closeMenu);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevState.open !== this.props.open) {
            this.setState({
                open: this.props.open
            });
        }
    };
    _proto.closeMenu = function closeMenu(event) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (_this.state.open) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 2:
                        _ctx.next = 4;
                        return (0,sleep["default"])(100);
                    case 4:
                        _this.setState({
                            open: false
                        });
                        if (_this.props.closeMenu) {
                            _this.props.closeMenu();
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.toggleMenu = function toggleMenu() {
        this.setState({
            open: !this.state.open
        });
        if (this.props.toggleOpen) {
            this.props.toggleOpen();
        }
    };
    _proto.logout = function logout1() {
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,logout/* default */.Z)();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.login = function login() {
        (0,events.sendEvent)(events.EVENTS.clicked.login);
        this.props.router.push("/login?to=" + encodeURIComponent((0,getPathname/* default */.Z)(this.props.router)));
    };
    _proto.renderAdmin = function renderAdmin() {
        var canView = CanViewAdmin(this.props.me);
        if (!canView) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminLink, {});
    };
    _proto.renderSalesPoint = function renderSalesPoint() {
        var canView = CanViewPos(this.props.me);
        if (!canView) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: "https://pos.getjusto.com",
            target: "blank",
            className: (Menu_styles_module_default()).menuLink,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdStore */.moe, {
                    size: 20
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: this.props.t("".concat(translatePrefix, ".labelPointOfSale"))
                })
            ]
        });
    };
    _proto.renderMenu = function renderMenu() {
        if (!this.props.me) return null;
        if (!this.state.open) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Menu_styles_module_default()).menu,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/settings",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (Menu_styles_module_default()).account,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Menu_styles_module_default()).name,
                                children: this.props.me.name === "Sin nombre" ? "Mi cuenta" : this.props.me.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Menu_styles_module_default()).email,
                                children: this.props.me.email
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Points, {
                    user: this.props.me,
                    config: this.props.pointsConfiguration
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/checkout",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (Menu_styles_module_default()).menuLink,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdShoppingCart */.kcE, {
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: this.props.t("fields.myCart", {
                                    ns: "generic"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/pedidos",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (Menu_styles_module_default()).menuLink,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdShopTwo */.PmM, {
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: this.props.t("fields.myOrders", {
                                    ns: "generic"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/settings",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (Menu_styles_module_default()).menuLink,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdSettings */.b9P, {
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: this.props.t("".concat(translatePrefix, ".labelMyAccount"))
                            })
                        ]
                    })
                }),
                this.renderAdmin(),
                this.renderSalesPoint(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Menu_styles_module_default()).logoutIcons,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        onClick: this.logout,
                        className: (Menu_styles_module_default()).menuLink,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdExitToApp */.IUz, {
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: this.props.t("".concat(translatePrefix, ".labelLogOut"))
                            })
                        ]
                    })
                })
            ]
        }, "menu");
    };
    _proto.renderIcon = function renderIcon() {
        if (this.props.me) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex divide-x",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Menu_styles_module_default()).menuText,
                        onClick: this.toggleMenu,
                        children: [
                            this.props.me.name === "Sin nombre" ? this.props.t("".concat(translatePrefix, ".labelMyAccount")) : this.props.me.name,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowDown */.Ix0, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteCoins/* default */.Z, {
                        loyaltyProgramConfig: this.props.loyaltyProgramConfig,
                        me: this.props.me
                    })
                ]
            });
        } else if (!this.props.userId) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton/* default */.Z, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Menu_styles_module_default()).menuText,
                children: this.props.t("".concat(translatePrefix, ".labelLoading"))
            });
        }
    };
    _proto.render = function render() {
        if (this.props.onlyOptions) return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_addons_css_transition_group_default()), {
            transitionName: "user-menu",
            transitionEnterTimeout: 200,
            transitionLeaveTimeout: 200,
            children: this.renderMenu()
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Menu_styles_module_default()).container,
            style: {
                background: "".concat(this.props.buttonColor),
                color: (0,getContrastColor/* default */.Z)(this.props.buttonColor || "#111")
            },
            children: [
                this.renderIcon(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_addons_css_transition_group_default()), {
                    transitionName: "user-menu",
                    transitionEnterTimeout: 200,
                    transitionLeaveTimeout: 200,
                    children: this.renderMenu()
                })
            ]
        });
    };
    return User;
}(react.Component)) || _class, _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "closeMenu", [
    esm["default"],
    _dec,
    _dec1
], Object.getOwnPropertyDescriptor(_class.prototype, "closeMenu"), _class.prototype), _dec2 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec3 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", []), _applyDecoratedDescriptor(_class.prototype, "toggleMenu", [
    esm["default"],
    _dec2,
    _dec3
], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMenu"), _class.prototype), _dec4 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec5 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", []), _applyDecoratedDescriptor(_class.prototype, "logout", [
    esm["default"],
    _dec4,
    _dec5
], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype), _dec6 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec7 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", []), _applyDecoratedDescriptor(_class.prototype, "login", [
    esm["default"],
    _dec6,
    _dec7
], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype), _class)) || _class) || _class) || _class) || _class) || _class;
/* harmony default export */ var Menu = ((0,dist_esm/* withTranslation */.Zh)()((0,router.withRouter)(User)));


/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 57905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"_3npmkdebVjKSwYjMcWL0iD primaryBackgroundColor buttonShadow","title":"_1-86oDbUcpPGGxItQkpS-j"};

/***/ }),

/***/ 80449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1h-aTgBjS9DnZxzvM-1N7w buttonShadow","icon":"m_RU5JotN4Jf9e-3gF3k","menuText":"_1uEIw5iXXaEhyWSG8QUUYB","menu":"lNxYI4NR0QXxUWpnkyzxG","account":"_2zN3KfL4DCAbiftdxv0WNT","name":"_36ixizDnhORbr-aHEfUQ7P","email":"_3xWt_t5piTol1xnIjIvXcI","menuLink":"_3jzCLpKIXuvIoz3TbBYXlh","divider":"Wrt-TFXAQAWTuMepYhXAC","logoutIcons":"_151yV5--gPTRNYM2th9W0c","user-menu-enter":"HxETBatahehao0Y8Bt6bB","user-menu-leave":"vQTRR_0XKJ20XD7Qmvvil","user-menu-leave-active":"_2jW3MvouCN3e8b65lNYhc","user-menu-enter-active":"_3eVYUg38RO2e4sWayZwayu"};

/***/ })

}]);